import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// all admins
export const fetchAdmins = createAsyncThunk("admins/fetchAdmins", async () => {
  try {
    const user = JSON.parse(localStorage.getItem("loggedUser"));
    const token = user?.token;
    const response = await axios.get(
      `${BASE_URL}/dashboard/admins`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Accept-Language": "ar",
        },
      }
    );
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || "Failed load data";
    return message;
  }
});

// add admins
export const addAdmins = createAsyncThunk(
  "admins/add",
  async (userData, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.post(
        `${BASE_URL}/dashboard/admins`,
        userData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept-Language": "ar",
          },
        }
      );
      return { ...response.data, message: "تمت إضافة الأدمن بنجاح" };
    } catch (error) {
      const message = error.response?.data?.message || "فشل في إضافة الأدمن";
      return rejectWithValue(message);
    }
  }
);
// get faq record
export const adminsRecord = createAsyncThunk(
  "admins/adminsRecord",
  async (id, { rejectWithValue }) => {
    try {
    const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.get(`${BASE_URL}/dashboard/admins/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept-Language": "ar",
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "فشل في تحميل بيانات الأدمن";
      return rejectWithValue(message);
    }
  }
);
// update admin
export const updateAdmins = createAsyncThunk(
  "admins/updateAdmins",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      // console.log('Update Admin API URL:', `${BASE_URL}/dashboard/admins/${id}/update`);
      // console.log('Update Admin Token:', token);
      // console.log('Update Admin Data:', Object.fromEntries(data.entries()));
      
      const response = await axios.post(
        `${BASE_URL}/dashboard/admins/${id}/update`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept-Language": "ar",
          },
        }
      );
      // console.log('Update Admin Response:', response.data);
      return { ...response.data, message: "تمت تحديث الأدمن بنجاح" };
    } catch (error) {
      // console.log('Update Admin Error:', error.response?.data);
      const message = error.response?.data?.message || "فشل في تحديث الأدمن";
      return rejectWithValue(message);
    }
  }
);
// delete admin
export const deleteAdmins = createAsyncThunk(
  "admins/deleteAdmins",
  async (id, { rejectWithValue }) => {
    try {
      const user = JSON.parse(localStorage.getItem("loggedUser"));
      const token = user?.token;
      const response = await axios.delete(
        `${BASE_URL}/dashboard/admins/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "فشل في حذف الأدمن";
      return rejectWithValue(message);
    }
  }
);
const AdminsSlice = createSlice({
  name: "admins",
  initialState: {
    admins: [],
    record: null,
    meta: null,
    isLoading: false,
    error: null,
    success: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdmins.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAdmins.fulfilled, (state, action) => {
        state.isLoading = false;
        state.meta = action.payload.meta || {
          current_page: 1,
          last_page: 1,
          per_page: action.payload.count || 100000,
          total: action.payload.count || 0
        };
        state.admins = action.payload;
      })
      .addCase(fetchAdmins.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to load data";
      })
      .addCase(addAdmins.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addAdmins.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(addAdmins.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to add data";
      })
      .addCase(adminsRecord.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(adminsRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.record = action.payload.data;
      })
      .addCase(adminsRecord.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to add data";
      })
      .addCase(updateAdmins.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateAdmins.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(updateAdmins.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          "Failed to update record";
      })
      .addCase(deleteAdmins.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAdmins.fulfilled, (state, action) => {
        state.isLoading = false;

        // Remove from data array inside admins
        if (state.admins?.data) {
          state.admins.data = state.admins.data.filter(
            (record) => record.id !== action.meta.arg
          );
        }

        state.success = action.payload?.message || "Deleted successfully";
      })
      .addCase(deleteAdmins.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          action.payload ||
          action.error?.message ||
          "Failed to delete admin";
      });
  },
});

export const { clearState } = AdminsSlice.actions;
export default AdminsSlice.reducer;
